// extracted by mini-css-extract-plugin
module.exports = {"container":"UserAvatar_container__3a2xi","profile-image":"UserAvatar_profile-image__1vxKt","initials":"UserAvatar_initials__3uZho"};